export default __webpack_public_path__ + "logo09db9106.png";